/**
 * Iter XX.221 — In-chat Connect Your Cricket card.
 *
 * Two shapes:
 *   · `variant="offer"`   — the standard third-turn or contextual offer
 *   · `variant="contextual"` — triggered by intent detection (user asked
 *                              about recent innings without a connection)
 */
import { useState } from "react";
import ConnectCricketModal from "./ConnectCricketModal";
import { dismissConnectPrompt, markSessionDismissed } from "../lib/connectCricket";

export default function ConnectCricketCard({
  variant = "offer",
  surface = "early_chat",
  onDismiss,
  onConnected,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const isContextual = variant === "contextual";

  return (
    <>
      <div
        className="rounded-xl border border-emerald-800/50 bg-emerald-950/30 p-4 my-2"
        data-testid={`connect-cricket-card-${variant}`}
      >
        <div className="text-sm font-medium text-emerald-300 mb-1">
          🏏 {isContextual ? "Gully can remember your performances" : "Let Gully know your cricket"}
        </div>
        <p className="text-sm text-neutral-300 leading-relaxed">
          {isContextual
            ? "Talk about your cricket and I'll build a record of your performances over time. Uploading scorecards or linking a profile speeds it up."
            : "Talk about your cricket. Upload a scorecard when you've got one. Optionally link a cricket profile. Gully will build your cricket record around you."
          }
        </p>
        <div className="mt-3 flex items-center gap-2">
          <button
            onClick={() => setModalOpen(true)}
            className="bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-medium px-3 py-1.5 rounded-lg"
            data-testid="connect-cricket-card-cta"
          >
            My Cricket
          </button>
          <button
            onClick={() => {
              setDismissed(true);
              markSessionDismissed();
              dismissConnectPrompt(surface);
              onDismiss?.();
            }}
            className="text-neutral-400 hover:text-white text-sm px-2 py-1.5"
            data-testid="connect-cricket-card-dismiss"
          >
            Maybe later
          </button>
        </div>
      </div>
      <ConnectCricketModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSuccess={(res) => {
          setDismissed(true);
          onConnected?.(res);
        }}
      />
    </>
  );
}
